module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9006/js/img/OperationsHub_Icon.svg"